// eslint-disable-next-line no-useless-escape
// const urlRegex_http = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/);
import swal from 'sweetalert2';
const urlRegex = new RegExp(/^((https?|ftp):\/\/)([\w\d]+\.?){2,}(:?\d{0,5}){1}(\/[[\&\=\(\+\?\#\w\d\-\_\)\.\/]*)*/);

// eslint-disable-next-line
const emailRegex = new RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/);

// Validate the given url
export const validURL = (url) => {
    const isUrlEmpty = !url;
    const isUrlFormatValid = urlRegex.test(url);

    const isUrlValid = !isUrlEmpty && isUrlFormatValid;

    return isUrlValid;
};

// Validate email
export const validEmail = (email) => {
  const isEmailEmpty = !email;
  const isEmailFormatValid = emailRegex.test(email);

  const isEmailValid = !isEmailEmpty && isEmailFormatValid;

  return isEmailValid;
};

export const displayErrorSwal = (body, title = 'An error occurred') => {
  swal.fire({
    type: 'error',
    title: title,
    text: body,
    confirmButtonText: 'Ok',
  });
}